import { render, staticRenderFns } from "./AllSubmissionsManagement.vue?vue&type=template&id=708ced5f&scoped=true"
import script from "./AllSubmissionsManagement.vue?vue&type=script&lang=js"
export * from "./AllSubmissionsManagement.vue?vue&type=script&lang=js"
import style0 from "./AllSubmissionsManagement.vue?vue&type=style&index=0&id=708ced5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ced5f",
  null
  
)

export default component.exports